import { Toast, Dialog } from 'vant'
import { GetRndStringNum } from '@/utils/Tool'
import { Bus } from '@/utils/Bus'
import Config from '@/utils/Config'
/**
 * 打开加载层
 */
export const ShowLoading = (title = '加载中', { mask = true } = {}) => {
  return new Promise((resolve, reject) => {
    Toast.loading({
      message: title,
      duration: 0,
      mask,
      icon: '/static/images/loading.png',
      forbidClick: true,
      onOpened: () => {
        resolve()
      }
    })
  })
}
/**
 * 关闭加载层
 */
export const CloseLoading = () => {
  return new Promise((resolve, reject) => {
    Toast.clear()
  })
}
/**
 * 打开消息提示框
 */
export const ShowToast = (title = '提示', { icon = 'none', image = '', duration = 1500, mask = false } = {}) => {
  return new Promise((resolve, reject) => {
    // 图标判断.
    let _icon = ''
    if (image) {
      _icon = image
    } else if (icon === 'success') {
      _icon = 'success'
    } else if (icon === 'fail') {
      _icon = 'cross'
    }
    Toast({
      message: title,
      icon: _icon,
      duration,
      mask,
      onOpened: () => {
        setTimeout(() => {
          resolve()
        }, 800)
      }
    })
  })
}
/**
 * 关闭消息提示框
 */
export const CloseToast = () => {
  return new Promise((resolve, reject) => {
    Toast.clear()
  })
}
/**
 * 打开询问框
 */
export const ShowConfirm = (content = '内容', { title = '提示', showCancel = true, cancelText = '取消', cancelColor = '#000000', confirmText = '确定', confirmColor = '#576B95', messageAlign = 'center' } = {}) => {
  return new Promise((resolve, reject) => {
    Dialog.confirm({
      title,
      message: content,
      confirmButtonText: confirmText,
      confirmButtonColor: confirmColor,
      cancelButtonText: cancelText,
      cancelButtonColor: cancelColor,
      showCancelButton: showCancel,
      messageAlign
    }).then(() => {
      resolve()
    }).catch(() => {
      reject(new Error())
    })
  })
}
/**
 * 打开操作菜单
 */
export const ShowActionSheet = (itemList = [], { itemColor = '#000000', valueKey = 'value' } = {}) => {
  return new Promise((resolve, reject) => {
    const _itemList = itemList.map(item => ({ ...item, name: item[valueKey] }))
    const busId = GetRndStringNum()
    Bus.$on(busId, ({ type, item, index }) => {
      if (type === 'confirm') {
        resolve({
          selectItem: item,
          tapIndex: index
        })
      } else if (type === 'cancel') {
        reject(new Error())
      }
    })
    Bus.$emit('interactive_action_sheet_open', {
      busId,
      itemList: _itemList,
      itemColor
    })
  })
}

export const mixin = {
  data () {
    return {
      action_sheet_show: false,
      action_sheet_list: [],
      action_sheet_broad_id: ''
    }
  },
  methods: {
    ActionSheetSelect (item, index) {
      this.$Bus.$emit(this.action_sheet_broad_id, {
        type: 'confirm',
        item,
        index
      })
    },
    ActionSheetCancel () {
      this.$Bus.$emit(this.action_sheet_broad_id, { type: 'cancel' })
    },
    getWxJssdk () {
      this.$Get('Common.getWxJssdk', {
        url: location.href
      }, { loading: false }).then(res => {
        if (res.status) {
          let config = res.data.config
          setTimeout(() => {
            /* eslint-disable */
            wx.config(config)
          }, 1000)
          setTimeout(() => {
            wx.ready(function () {
              console.log('ready')
              // _this.ShareManage()
            })
            wx.error(function (res) {
              console.log('err', res)
              // alert(res.errMsg)
            })
          }, 2000)
        }
      })
    }
  },
  created () {
    this.$Bus.$on('interactive_action_sheet_open', options => {
      this.action_sheet_list = options.itemList
      this.action_sheet_show = true
      this.action_sheet_broad_id = options.busId
    })
    let loginBackUrl = this.$GetStorage('login_back_url', 'local')
    if (location.search.indexOf('?code') === 0) {
      let code = location.search.split('=')[1]
      // console.log('code', code)
      // 根据code 获取token
      this.$Get('Common.getTokenByCode', { code }).then(res => {
        if (res.status) {
          let loginInfo = res.data
          this.$SetStorage('login_info', loginInfo, 'local')
          this.$SetStorage(Config.tokenStorageKey, loginInfo.token, 'local')
          this.$RemoveStorage('login_back_url', 'local')
          // this.$nav(loginBackUrl.name, loginBackUrl.query, 'redirectTo')
          location.href = location.origin + '/#' + loginBackUrl.fullPath
        } else {
          // 如果登录授权失败
          this.$Bus.$emit('goLogin')
        }
      })
    }
    this.$Bus.$on('goLogin', options => {
      // console.log('route', this.$route)
      this.$SetStorage('login_back_url', { name: this.$route.name, fullPath: this.$route.fullPath, query: this.$route.query }, 'local').then(res => {
        // console.log('SetStorage', res)
      }).catch(() => {
        // console.log('SetStorage-err', err)
      })
      let redirectUrl = location.origin + '/#' + encodeURIComponent(this.$route.fullPath)
      // console.log('redirectUrl', redirectUrl)
      location.href = this.$getApi('Common.login') + '?redirect_url=' + redirectUrl
    })
  },
  mounted () {
    // if (document.documentElement.clientWidth < 375) {
    const fz = (document.documentElement.clientWidth) * 50 / 375
    document.getElementById('html').style.fontSize = `${fz}px`
    // }
  }
}

export default {
  install: Vue => {
    Vue.prototype.$ShowToast = ShowToast
    Vue.prototype.$ShowLoading = ShowLoading
    Vue.prototype.$CloseLoading = CloseLoading
    Vue.prototype.$CloseToast = CloseToast
    Vue.prototype.$ShowConfirm = ShowConfirm
    Vue.prototype.$ShowActionSheet = ShowActionSheet
  },
  ShowLoading,
  CloseLoading,
  ShowToast,
  CloseToast,
  ShowConfirm,
  ShowActionSheet
}
